import React from "react";
import { Dialog } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingModalProps {
  show: boolean
}

function LoadingModal(props: LoadingModalProps) {
  return <Dialog fullScreen
    open={props.show}
    PaperProps={{
      style: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    }}
  >
    <CircularProgress sx={{margin: 'auto'}} />
  </Dialog>
}
  
export default LoadingModal;